module.exports = __webpack_public_path__ + "static/media/INSTANT_PAYMENT.63c310ce.svg";